export default "__VITE_ASSET__cf8c495b__"